/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

type BackIconProps = IconType & {
  variant?: 'default' | 'date';
};

export const BackIcon: FC<BackIconProps> = (props) => {
  const { width, height, color, variant = 'default' } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };

  if (variant === 'date') {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}
      >
        <g id="Shopicon">
          <g>
            <polygon points="30.585,6.586 33.413,9.414 18.827,24 33.413,38.586 30.585,41.414 13.171,24" />
          </g>
        </g>
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0266 5.59615L15.4175 3.98706L6.41748 12.9871L15.4175 21.9871L17.0266 20.378L9.63566 12.9871L17.0266 5.59615Z"
        fill={color}
      />
    </svg>
  );
};
